const productListData = [
  {
    id: 16,
    image: 'https://http2.mlstatic.com/D_NQ_NP_850813-MLA48317742358_112021-O.webp',
    offerType: 'none',
    title: 'Paleta Raqueta Mata Mosca Mosquito Electrica Recargable Usb',
    price: 1200,
    cup: true,
    discount: 65,
    interestFreeFees: '0',
    ship: {
      type: 'Llega mañana',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '3',
      amount: '2',
    },
    redirect: '/product',
  },
  {
    id: 0,
    image: 'https://http2.mlstatic.com/D_NQ_NP_611690-MLA41179103513_032020-O.webp',
    offerType: 'OFERTA DEL DÍA',
    title: 'Motosierra a nafta Philco 52cc MJPMO217 2.4hp',
    price: 9499,
    cup: false,
    discount: 40,
    interestFreeFees: '0',
    ship: {
      type: 'Llega gratis mañana',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '4.5',
      amount: '680',
    },
    redirect: '/product',
  },
  {
    id: 3,
    image: 'https://http2.mlstatic.com/D_NQ_NP_902502-MLA47752761623_102021-O.webp',
    offerType: 'none',
    title: 'Kit Herramientas De Jardinería Con Bolsa - Klatter',
    price: 3489,
    cup: false,
    discount: 12,
    interestFreeFees: '0',
    ship: {
      type: 'Llega gratis mañana',
      full: true,
    },
    brand: 'Klatter',
    rated: {
      starAverage: '4',
      amount: '13',
    },
    redirect: '/product',
  },
  {
    id: 4,
    image: 'https://http2.mlstatic.com/D_NQ_NP_862194-MLA42149717446_062020-O.webp',
    offerType: 'none',
    title: 'Pileta estructural rectangular Bestway 56403 con capacidad de 2300 litros de 2.59m de largo x 1.7m de ancho  azul',
    price: 17399,
    cup: false,
    discount: 39,
    interestFreeFees: '6',
    ship: {
      type: 'none',
      full: false,
    },
    brand: 'Bestway',
    rated: {
      starAverage: '4.5',
      amount: '96'
    },
    redirect: '/product',
  },
  {
    id: 5,
    image: 'https://http2.mlstatic.com/D_NQ_NP_717303-MLA46508468787_062021-O.webp',
    offerType: 'none',
    title: 'Set Parrillero Kit Asador Set Asado Juego Asado Kit Cod 1025',
    price: 1199,
    cup: false,
    discount: 14,
    interestFreeFees: '0',
    ship: {
      type: 'Llega mañana',
      full: true,
    },
    brand: 'generic',
    rated: {
      starAverage: '2',
      amount: '13',
    },
    redirect: '/product',
  },
  {
    id: 6,
    image: 'https://http2.mlstatic.com/D_NQ_NP_850813-MLA48317742358_112021-O.webp',
    offerType: 'none',
    title: 'Paleta Raqueta Mata Mosca Mosquito Electrica Recargable Usb',
    price: 1200,
    cup: true,
    discount: 65,
    interestFreeFees: '0',
    ship: {
      type: 'Llega mañana',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '3',
      amount: '2',
    },
    redirect: '/product',
  },
  {
    id: 1,
    image: 'https://http2.mlstatic.com/D_NQ_NP_842402-MLA48108304641_112021-O.webp',
    offerType: 'MÁS VENDIDO',
    title: 'Pastillas Cloro Triple Accion Multiaccion 200gr 5kg Nataclor',
    price: 5495,
    cup: false,
    discount: 0,
    interestFreeFees: '0',
    ship: {
      type: 'Llega gratis mañana',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '4',
      amount: '13',
    },
    redirect: '/product',
  },
  {
    id: 7,
    image: 'https://http2.mlstatic.com/D_NQ_NP_641505-MLA46805950270_072021-O.webp',
    offerType: 'none',
    title: 'Gazebo Autoarmable 3x3 Reforzado Playa Paredes Impermeable',
    price: 41654,
    cup: false,
    discount: 22,
    interestFreeFees: '6',
    ship: {
      type: 'Envío gratis',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '3',
      amount: '2',
    },
    redirect: '/product',
  },
  {
    id: 8,
    image: 'https://http2.mlstatic.com/D_NQ_NP_628110-MLA42957480060_072020-O.webp',
    offerType: 'none',
    title: 'Bordeadora Plumita Magnum 1000W color azul y negro 220V',
    price: 8002,
    cup: false,
    discount: 0,
    interestFreeFees: '0',
    ship: {
      type: 'Envío gratis',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '4.5',
      amount: '578',
    },
    redirect: '/product',
  },


  {
    id: 11,
    image: 'https://http2.mlstatic.com/D_NQ_NP_842402-MLA48108304641_112021-O.webp',
    offerType: 'MÁS VENDIDO',
    title: 'Pastillas Cloro Triple Accion Multiaccion 200gr 5kg Nataclor',
    price: 5495,
    cup: false,
    discount: 0,
    interestFreeFees: '0',
    ship: {
      type: 'Llega gratis mañana',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '4',
      amount: '13',
    },
    redirect: '/product',
  },
  {
    id: 12,
    image: 'https://http2.mlstatic.com/D_NQ_NP_800016-MLA47753936126_102021-O.webp',
    offerType: 'OFERTA RELÁMPAGO',
    title: 'Kit Herramientas De Jardinería - Klatter',
    price: 1939,
    cup: false,
    discount: 35,
    interestFreeFees: '0',
    ship: {
      type: 'none',
      full: true,
    },
    brand: 'Klatter',
    rated: {
      starAverage: '4',
      amount: '13',
    },
    redirect: '/product',
  },
  {
    id: 13,
    image: 'https://http2.mlstatic.com/D_NQ_NP_902502-MLA47752761623_102021-O.webp',
    offerType: 'none',
    title: 'Kit Herramientas De Jardinería Con Bolsa - Klatter',
    price: 3489,
    cup: false,
    discount: 12,
    interestFreeFees: '0',
    ship: {
      type: 'Llega gratis mañana',
      full: true,
    },
    brand: 'Klatter',
    rated: {
      starAverage: '4',
      amount: '13',
    },
    redirect: '/product',
  },
  {
    id: 9,
    image: 'https://http2.mlstatic.com/D_NQ_NP_969591-MLA47574247083_092021-O.webp',
    offerType: 'none',
    title: 'Hamaca Sillon Columpio Macrame Colgante Interior Exterior',
    price: 16551,
    cup: true,
    discount: 8,
    interestFreeFees: '0',
    ship: {
      type: 'Llega gratis hoy',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '4',
      amount: '53',
    },
    redirect: '/product',
  },
  {
    id: 14,
    image: 'https://http2.mlstatic.com/D_NQ_NP_862194-MLA42149717446_062020-O.webp',
    offerType: 'none',
    title: 'Pileta estructural rectangular Bestway 56403 con capacidad de 2300 litros de 2.59m de largo x 1.7m de ancho  azul',
    price: 17399,
    cup: false,
    discount: 39,
    interestFreeFees: '6',
    ship: {
      type: 'none',
      full: false,
    },
    brand: 'Bestway',
    rated: {
      starAverage: '4.5',
      amount: '96'
    },
    redirect: '/product',
  },
  {
    id: 2,
    image: 'https://http2.mlstatic.com/D_NQ_NP_800016-MLA47753936126_102021-O.webp',
    offerType: 'OFERTA RELÁMPAGO',
    title: 'Kit Herramientas De Jardinería - Klatter',
    price: 1939,
    cup: false,
    discount: 35,
    interestFreeFees: '0',
    ship: {
      type: 'none',
      full: true,
    },
    brand: 'Klatter',
    rated: {
      starAverage: '4',
      amount: '13',
    },
    redirect: '/product',
  },
  {
    id: 15,
    image: 'https://http2.mlstatic.com/D_NQ_NP_717303-MLA46508468787_062021-O.webp',
    offerType: 'none',
    title: 'Set Parrillero Kit Asador Set Asado Juego Asado Kit Cod 1025',
    price: 1199,
    cup: false,
    discount: 14,
    interestFreeFees: '0',
    ship: {
      type: 'Llega mañana',
      full: true,
    },
    brand: 'generic',
    rated: {
      starAverage: '2',
      amount: '13',
    },
    redirect: '/product',
  },
  {
    id: 17,
    image: 'https://http2.mlstatic.com/D_NQ_NP_641505-MLA46805950270_072021-O.webp',
    offerType: 'none',
    title: 'Gazebo Autoarmable 3x3 Reforzado Playa Paredes Impermeable',
    price: 41654,
    cup: false,
    discount: 22,
    interestFreeFees: '6',
    ship: {
      type: 'Envío gratis',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '3',
      amount: '2',
    },
    redirect: '/product',
  },
  {
    id: 10,
    image: 'https://http2.mlstatic.com/D_NQ_NP_611690-MLA41179103513_032020-O.webp',
    offerType: 'OFERTA DEL DÍA',
    title: 'Motosierra a nafta Philco 52cc MJPMO217 2.4hp',
    price: 9499,
    cup: false,
    discount: 40,
    interestFreeFees: '0',
    ship: {
      type: 'Llega gratis mañana',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '4.5',
      amount: '680',
    },
    redirect: '/product',
  },
  {
    id: 18,
    image: 'https://http2.mlstatic.com/D_NQ_NP_628110-MLA42957480060_072020-O.webp',
    offerType: 'none',
    title: 'Bordeadora Plumita Magnum 1000W color azul y negro 220V',
    price: 8002,
    cup: false,
    discount: 0,
    interestFreeFees: '0',
    ship: {
      type: 'Envío gratis',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '4.5',
      amount: '578',
    },
    redirect: '/product',
  },
  {
    id: 19,
    image: 'https://http2.mlstatic.com/D_NQ_NP_969591-MLA47574247083_092021-O.webp',
    offerType: 'none',
    title: 'Hamaca Sillon Columpio Macrame Colgante Interior Exterior',
    price: 16551,
    cup: true,
    discount: 8,
    interestFreeFees: '0',
    ship: {
      type: 'Llega gratis hoy',
      full: false,
    },
    brand: 'generic',
    rated: {
      starAverage: '4',
      amount: '53',
    },
    redirect: '/product',
  },
]

export default productListData